export default {
  tutorPart: ({ plural, named }) =>
    plural([
      "Es tutor de <strong>una </strong>formación",
      `Es tutor de <strong>${named("number")}</strong> formaciones`,
    ]),
  studeaManagerPart: ({ plural, named }) =>
    plural([
      "Actualmente es administrador en <strong>una</strong> formación",
      `Actualmente es administrador en <strong>${named("number")}</strong> formaciones`,
    ]),
  apprenticeMasterPart: ({ plural, named }) =>
    plural([
      "Actualmente es mentor en <strong>una</strong> formación",
      `Actualmente es mentor en <strong>${named("number")}</strong> formaciones`,
    ]),
  promotion: "Promoción",
  "Training courses list": "Lista de formaciones",
  loadingTrainingCourses: "Carga de formaciones en curso...",
  trainingCourseInfos: "Información sobre la formación",
  "Useful links": "Enlaces útiles",
  trainingCoursesSelected: "Formaciones seleccionadas",
  badgeFiltersLabel: "Filtrar por funcionalidad",
  badgeFiltersResultsCount: ({ plural, named }) =>
    plural(["Ningún resultado", `${named("count")} resultado`, `${named("count")} resultados`]),
  year: "Año",
  training_course: {
    errors: {
      start_year_upper_than_end_year: "El año de inicio debe ser inferior al año de finalización",
      month_duration_too_long:
        "La duración en meses debe ser inferior o igual a la diferencia entre el año de finalización y el año de inicio",
    },
  },
  user_already_studea_manager_on_training_course: "Este usuario ya está asignado a un cuaderno para esta promoción",
  trainingCourse_document: {
    planning: "Planificación",
    program: "Programa",
    rncpSheet: "Ficha RNCP",
    job_description: "Formulario de descripción personalizada del puesto",
  },
  see_archive_training_courses: "Ver las promociones archivadas",
};
